import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createAuth0 } from '@auth0/auth0-vue'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
const app = createApp(App)

app
    .component('EasyDataTable', Vue3EasyDataTable)
    .use(store)
    .use(router)
    .use(
        createAuth0({
            domain: process.env.VUE_APP_AUTH0_DOMAIN,
            clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
            authorizationParams: {
                redirect_uri: process.env.VUE_APP_AUTH0_REDIRECT_URI,
            },
            
        })
    )
    .mount('#app')
// update